module.exports = __webpack_public_path__ + "img/download-all.fc94d4c8.svg";